import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { FHEBoxAutoComplete } from 'data/components';
import { tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import getSelectors from '../../selectors';

class Step1 extends PureComponent {
    static propTypes = {
        boxMac: PropTypes.string.isRequired,
        history: PropTypes.object.isRequired,
        setMacAddress: PropTypes.func.isRequired,
        prefixCenter: PropTypes.string.isRequired,
        boxesArray: PropTypes.array.isRequired
    };

    constructor(props) {
        super(props);
    }

    handleSelect = (name, mac, id) => {
        const { setMacAddress } = this.props;
        setMacAddress(mac, id);
    };

    render() {
        const { prefixCenter, boxesArray, boxMac, history } = this.props;
        return (
            <Grid container spacing={3} justify="center" alignItems="center">
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEBoxAutoComplete
                        id="boxMac"
                        baseValue={boxMac === null || !boxMac ? prefixCenter : boxMac}
                        label={Translator.translate(`general.table.column.boxMac`, Translator.translate(`${history.environment}.centerName`))}
                        name="boxMac"
                        data={boxesArray}
                        selectData={this.handleSelect}
                    />
                </Grid>
            </Grid>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        boxesArray: selectors.getBoxesArray(state),
        prefixCenter: selectors.getPrefixCenter(state)
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Home/components/stepper/Step1',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, {}), dispatch)
        )(Step1)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/components/stepper/Step1.js